/**
 * Global breakpoints used across the application.
 * These values represent the minimum width for each device category.
 *
 * Mobile:  0 — TABLET-1  (0–1099px)
 * Tablet:  TABLET — LAPTOP-1  (1100–1279px)
 * Laptop:  LAPTOP — DESKTOP  (1280–1440px)
 * Desktop: >DESKTOP  (>1440px)
 *
 * SIDEBAR_DOCK is deliberately far below TABLET: an icon rail costs 76px, which
 * even a portrait tablet can spare, so only phones fall back to the hamburger
 * drawer. The wider categories above still decide the data-table layout, where
 * a narrow screen really does need a different design.
 * DESKTOP is where the docked column defaults to fully expanded.
 * Keep in sync with src/styles/_breakpoints.scss.
 */
/*
 * ⚠️ HAT-1170: SIDEBAR_DOCK הועלה מ-768 ל-1100, בכוונה ובניגוד להערה
 * שלמעלה. העיצוב שממנו מעבירים (hatzdaka-nedarim) אינו מכיר מסילת
 * אייקונים: בטאבלט, כמו בטלפון, אין סרגל צד בזרימה — יש המבורגר ומגירה,
 * וניווט הלוחות הוא סרגל הטאבים שבראש המסך. מסילה של 76px לצד כרטיסים
 * ברוחב 600 היא בדיוק "שני ניווטים לאותם מסכים באותו מסך".
 *
 * תופעת לוואי רצויה: מעכשיו isSidebarDocked ו-isMobile נחתכים באותה
 * נקודה, ומתחת ל-1100 יש עולם מובייל אחד ולא שניים שחלוקים ב-768–1099.
 */
export const BREAKPOINTS = {
  /** HAT-1170: מתחת לזה טלפון; 768–959 טאבלט; 960–1099 טאבלט גדול. ר' _breakpoints.scss. */
  PHONE: 768,
  TABLET_LARGE: 960,
  SIDEBAR_DOCK: 1100,
  TABLET: 1100,
  LAPTOP: 1280,
  DESKTOP: 1440,
} as const;
